import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import NoDataIcon from "../../../../assets/svg/no-data.svg";
const customComColors = {
  "Community A": "#3BBEE8",
  "Community B": "#004877",
  "Community C": "#004"
};
const GenderVsCommunityChart = ({ isDataAvailable, graphData }) => {
  const theme = {
    axis: {
      ticks: {
        text: {
          fontSize: 10,
          fill: `var(--stat-text)`,
          fontWeight: 400
        }
      },
      legend: {
        text: {
          fontSize: 12,
          fill: `var(--stat-text)`,
          fontWeight: 400
        }
      }
    }
  };
  return (
    <>
      {" "}
      <div className='revenue-map-chart' style={{ height: "300px" }}>
        {isDataAvailable ? (
          <>
            {" "}
            <div className='flex justify-between'>
              <div className='ml-4 mt-4 flex items-center legend'>
                {["Community A", "Community B", "Community C"].map((legend) => (
                  <div
                    key={legend}
                    className='mr-4 flex items-center'
                    style={{ color: customComColors[legend] }}
                  >
                    <div
                      className='w-3 h-3  mr-1'
                      style={{ backgroundColor: customComColors[legend] }}
                    ></div>
                    <span>{legend}</span>
                  </div>
                ))}
              </div>
            </div>
            <ResponsiveBar
              data={graphData}
              keys={["Community A", "Community B", "Community C"]}
              indexBy='gender'
              margin={{ top: 10, right: 5, bottom: 40, left: 80 }}
              padding={0.3}
              layout='horizontal'
              colors={(e) => customComColors[e.id]} // Adjust color as needed
              borderColor={{ from: "color", modifiers: [["darker", "1.6"]] }}
              axisTop={null}
              axisRight={null}
              axisBottom={{
                tickSize: 0,
                tickPadding: 0,
                tickRotation: 0,
                legend: "No of People",
                legendPosition: "middle",
                legendOffset: 30,
                format: (value) => `${value}%`
              }}
              axisLeft={{
                tickSize: 0,
                tickPadding: 5,
                tickRotation: 0,
                legend: "Gender",
                legendPosition: "middle",
                legendOffset: -70
              }}
              theme={theme}
              enableGridY={false}
              enableLabel={false}
              labelSkipWidth={12}
              labelSkipHeight={12}
              labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
              legends={[]}
              tooltip={({ id, value }) => (
                <strong>{`${id}: ${value.toFixed(2)}%`}</strong>
              )}
            />
          </>
        ) : (
          <div className='no-data-icon'>
            <img src={NoDataIcon} alt='' />
            <span>No Data Available</span>
          </div>
        )}
      </div>
    </>
  );
};

export default GenderVsCommunityChart;
